import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { CheckPermissionRender, checkPermission } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import { Checkbox } from "@mui/material";
import { updateUserPermissionsCall } from "../../api/api";
import Modal from "../../components/modal";

const DISABLED_PERMISSIONS = permissions()
  .consumption()
  .update()
  .payment()
  .update()
  .profile()
  .create()
  .orgConfig()
  .create()
  .consumptionSummary()
  .create()
  .update()
  .paymentHistory()
  .create()
  .update()
  .list();

export default function AdminPermissions({
  onClose,
  reload,
  user,
  userPermissions,
  allPermissions,
}) {
  const [state, setState] = useState({
    id: null,
    name: "",
    permissions: [],
  });

  const onUpdate = async () => {
    if (!state.id) {
      return global.showAlert(
        "Validation Errors",
        "Something Went wrong. Please try again later",
        "warning"
      );
    }
    const parsedPermissions = JSON.parse(JSON.stringify(state.permissions));
    parsedPermissions.forEach((p) => {
      delete p.permission.id;
      delete p.permission.permission;
    });
    const response = await updateUserPermissionsCall(state.id, {
      permissions: parsedPermissions,
    });
    if (response) {
      reload();
    }
  };

  useEffect(() => {
    if (user) {
      allPermissions.forEach((allPermission) => {
        const userPermission = userPermissions.find(
          (userPermission) => userPermission.permission.id === allPermission.id
        );
        if (userPermission) {
          allPermission.permission = userPermission;
        } else {
          allPermission.permission = {
            read: false,
            create: false,
            update: false,
            delete: false,
          };
        }
      });
      setState({
        id: user.id,
        name: user.name,
        permissions: allPermissions,
      });
    }
  }, [user]);

  const CheckBox = ({ permission, access, disabled }) => {
    return (
      <Checkbox
        checked={permission.permission[access]}
        onChange={(_, checked) => {
          const permissionsCopy = JSON.parse(JSON.stringify(state.permissions));
          permissionsCopy.find((p) => p.id === permission.id).permission[access] = checked;
          setState({ ...state, permissions: permissionsCopy });
        }}
        disabled={
          !checkPermission(permissions().rolePermission().create().update().list()) || disabled
        }
      />
    );
  };

  const Header = ({ name }) => {
    return (
      <MDTypography fontWeight="medium" fontSize={13} textTransform="uppercase">
        {name}
      </MDTypography>
    );
  };

  return (
    user && (
      <Modal
        open={user}
        title={"User permissions"}
        actions={
          <CheckPermissionRender
            permissions={permissions().rolePermission().create().update().list()}
          >
            <MDBox display="flex" gap={1} justifyContent="right">
              <MDButton onClick={onUpdate} variant="gradient" color="info">
                update
              </MDButton>
              <MDButton onClick={onClose} variant="gradient" color="error">
                cancel
              </MDButton>
            </MDBox>
          </CheckPermissionRender>
        }
      >
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <MDInput type="string" label="Name" fullWidth value={state.name} disabled />
          </MDBox>

          <table align="center" style={{ margin: "auto" }}>
            <thead>
              <tr>
                <th align="left">
                  <Header name={"name"} />
                </th>
                <th align="center" width="60px">
                  <Header name={"view"} />
                </th>
                <th align="center" width="60px">
                  <Header name={"create"} />
                </th>
                <th align="center" width="60px">
                  <Header name={"update"} />
                </th>
                {/* <th align="center" width="60px">
                  <Header name={"delete"} />
                </th> */}
              </tr>
            </thead>
            <tbody>
              {state.permissions.map((permission, index) => (
                <tr key={index}>
                  <td>
                    <MDTypography fontSize={13}>{permission.name}</MDTypography>
                  </td>
                  {["read", "create", "update" /*"delete"*/].map((access, index) => {
                    const isDisabled = DISABLED_PERMISSIONS.includes(
                      `${permission.name}_${access.toUpperCase()}`
                    );
                    return (
                      <td align="center" key={index}>
                        {!isDisabled && <CheckBox permission={permission} access={access} />}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </MDBox>
      </Modal>
    )
  );
}
